import styled from "styled-components";

export const ContainerTop = styled.div`
  height: 100px;
  width: 100%;
  background-color: var(--color-latex30);
  color: var(--color-white);
  display: flex;
  flex-direction: column;
`;

export const SearcherZone = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  .drag-and-drop-columns {
    width: 70%;
    display: flex;
    align-items: center;
    padding-left: 20px;
    gap: 10px;
  }
  .searcher {
    width: 30%;
    display: flex;
    align-items: center;
    width: 400px;
    gap: 20px;
    input {
      width: 151px;
      height: 32px;
      border-radius: 4px;
      border: none;
      padding-left: 10px;
      background-color:var(--color-white);
      font-weight: bold;
      color: var(--color-black);
    }
  }
  .acordeon-col{ 
    position: relative;
    width: max-content;
    padding: 8px 20px;
    border: 1px solid var(--color-white);
    background-color: transparent;
  }
  .cruz {
    width: max-content;
    height: max-content;
    position: absolute;
    /* background-color: red; */
    top: 1px;
    right: 4px;
    font-size: 14px;
  }
`;

export const ColumnTopZone = styled.div`
  width: max-content;
  height: 40px;
  /* border-top: 1px solid var(--color-white); */
  position: relative; 
  display: flex;
  .view{
    border-top: 1px solid var(--color-white);
    display: flex;
    width: max-content;
    height: 40px;
    position: absolute;
    left: 0;
    ${({borderActive}) => borderActive ?`z-index:1`: "z-index:2"}
  }
  .border-view {
    display: flex;
    width: max-content;
    height: 40px;
    position: absolute;
    left: 0;
    ${({borderActive}) => borderActive ?`z-index:2`: "z-index:1"}
  }

`;

export const Column = styled.div`
  position: relative;
  width: ${({ width, name }) => (width && !name ? `${width}px` : "50px")};
  /* max-width: ${({maxWidth}) => maxWidth ? `${maxWidth}px` : ""}; */
  min-width: 50px; 
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border-right: 1px solid var(--color-white);
  text-transform: capitalize;
  cursor: pointer;
  input {
  cursor: pointer;

  }

  ${({second,mouseLive}) => {
    return (
      second && mouseLive ? `
      border-right: 1px solid var(--color-danger);
      height: 538px; 
      `: second === false ? "border-right: 1px solid transparent;" : ""
    )
  }}
  .border {
    position: absolute;
    width: 10px;
    height: 100%;
    /* background-color: red; */
    right: 0;
    cursor: col-resize;

    ${({ mouseLive }) =>
      mouseLive
        ? `
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            z-index: 1;
            background-color:transparent; 
            `
        : ""}
  }
  .content-border {
    height: 100%; 
    width: 100%; 
  }
  .border-new{
    position: absolute;
    width: 40px;
    height: 100%;
    /* background-color: rgba(0,0,0,0.1); */
    right: -20px;
  }
`;

export const ColumnMoveBorder = styled.div`
  width: ${({ width }) => (width ? `${width}px` : "50px")};
  height: 100%;
  position: relative;
  border-right: 1px solid transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  /* cursor: pointer; */

  .content-border {
    width: 100%;
    height: 100%;
    display: flex; 
    justify-content: center; 
    align-items: center;
  }


  ${({ mouseLive }) =>
    mouseLive
      ? `
           border-right: 1px solid var(--color-danger); 
           height: 536px;
            `
      : ""}

  .border {
    position: absolute;
    width: 3px;
    height: 100%;
    background-color: transparent;
    right: 0;
    cursor: col-resize;

    ${({ mouseLive }) =>
      mouseLive
        ? `
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            z-index: 1;
            background-color:transparent; 
            `
        : ""}
  }
`;
